var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-bold",attrs:{"color":_vm.meta.color,"small":"","label":"","outlined":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" "+_vm._s(_vm.meta.icon)+" ")]),_vm._v(" "+_vm._s(_vm.meta.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }